import { getContextPath, getRepository } from '@things-factory/shell'

import { PlayGroup } from '../service/play-group/play-group.js'
import { BoardHistory } from '../service/board/board-history.js'

export const headlessPlaylist = async (target, draft: boolean = false) => {
  var { domain, id, name } = target || {}

  if (id || name) {
    const repository = getRepository(PlayGroup)

    if (id) {
      var playGroup = await repository.findOne({
        where: { domain: { id: domain.id }, id },
        relations: ['boards']
      })
    } else if (name) {
      var playGroup = await repository.findOne({
        where: { domain: { id: domain.id }, name },
        relations: ['boards']
      })
    }

    if (!draft && playGroup) {
      const { boards } = playGroup
      for (let board of boards) {
        const latestReleased =
          board.state == 'released'
            ? board
            : await getRepository(BoardHistory)
                .createQueryBuilder('history')
                .where('history.originalId = :originalId', { originalId: board.id })
                .orderBy('history.version', 'DESC')
                .limit(1)
                .getOne()

        if (latestReleased) {
          board.model = latestReleased.model
        }
      }
    }

    playGroup.boards = playGroup.boards.sort((a, b) => {
      // 배열 A에 포함된 아이디의 순서를 가져옵니다.
      const indexOfOrder = (playGroup.order || []).indexOf(a.id)
      const indexOfBoards = (playGroup.order || []).indexOf(b.id)

      // 두 아이디의 순서를 비교하여 정렬합니다.
      if (indexOfOrder === -1 && indexOfBoards === -1) {
        // 두 아이디 모두 배열 A에 없는 경우, 그대로 유지합니다.
        return 0
      } else if (indexOfOrder === -1) {
        // 아이디 A만 배열 A에 없는 경우, 아이디 B를 먼저 정렬합니다.
        return 1
      } else if (indexOfBoards === -1) {
        // 아이디 B만 배열 A에 없는 경우, 아이디 A를 먼저 정렬합니다.
        return -1
      } else {
        // 두 아이디 모두 배열 A에 있는 경우, 배열 A의 아이디 순서대로 정렬합니다.
        return indexOfOrder - indexOfBoards
      }
    })
  } else {
    throw 'parameter id or name mandatory'
  }

  return {
    base: getContextPath(domain),
    playGroup
  }
}
